import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'elastic-series-chooser',
  templateUrl: './series-chooser.component.html',
  styleUrls: ['./series-chooser.component.scss']
})
export class SeriesChooserComponent implements OnInit {

  @Input() series;

  @Input() series_type = 'all';

  @Input() type = "dashboard";

  @Input() fc = function(id = 0) {};

  @Input() activeEvent = 0;

  constructor() { }

  ngOnInit() {
  }

}
